import React, { useEffect, useState } from 'react';
import { SelectArrayInputProps } from 'react-admin';

import { SelectArrayInput } from '@components';
import { adminHttp } from '@network';
import { Admin } from '@types';

export const DealerOwnerFilter = (props: SelectArrayInputProps) => {
  const [options, setOptions] = useState<{ id: number, name: string }[]>([]);

  useEffect(() => {
    (async () => {
      const list: Admin[] = await adminHttp.getAll();
      setOptions(list.map(i => ({ id: i.id, name: i.name }))
        .sort((a, b) => a.name > b.name ? 1 : -1));
    })();
  }, []);

  return (
    <SelectArrayInput
      {...props}
      choices={options}
      className="MS-field"
      style={{ width: 280 }}
      alwaysOn
    />
  );
};
